import { featureFlagsQuery, isFeatureEnabled } from "@common/api/feature-flags"
import type { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

export async function requireFeatureFlag(
  queryClient: QueryClient,
  flag: string,
): Promise<void> {
  const flags = await queryClient.ensureQueryData(featureFlagsQuery())
  if (!isFeatureEnabled(flags, flag)) {
    throw redirect({ to: "/" })
  }
}
